import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { PWAInstallPromptComponent } from './pwa-install-prompt.component';

export const ngxPwaInstallPromptModule = angular.module('ngxPwaInstallPromptModule', [])
	.directive('ngxPwaInstallPrompt', downgradeComponent({ component: PWAInstallPromptComponent }))
	.name;
